import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimUpdateWorkOrderChangeGql } from '../bimWorkOrderChangeCreateOrEditQueries';

export const useUpdateWorkOrderChange = (dependenciesUpdater: (() => void) | undefined) => {
    const [resetUpdatingData] = useResetStoreData({ requestId: 'bimUpdateWorkOrderChange' });

    const [
        bimUpdateWorkOrderChangeData,
        bimUpdateWorkOrderChangeStatus,
        bimUpdateWorkOrderError,
        bimUpdateWorkOrderChangeRequest,
    ] = useRequest({
        requestId: 'bimUpdateWorkOrderChange',
        query: bimUpdateWorkOrderChangeGql,
        withEffect: false,
        dependenciesUpdater,
    });

    const isUpdatingInProgress = useMemo(
        () => bimUpdateWorkOrderChangeStatus === RequestStatus.FETCHING,
        [bimUpdateWorkOrderChangeStatus],
    );

    return useMemo(
        () => ({
            updatingData: bimUpdateWorkOrderChangeData?.bimUpdateWorkOrderChange,
            updatingStatus: bimUpdateWorkOrderChangeStatus,
            updatingError: bimUpdateWorkOrderError,
            updatingRequest: bimUpdateWorkOrderChangeRequest,
            resetUpdatingData,
            isUpdatingInProgress,
        }),
        [
            bimUpdateWorkOrderChangeData?.bimUpdateWorkOrderChange,
            bimUpdateWorkOrderChangeRequest,
            bimUpdateWorkOrderChangeStatus,
            bimUpdateWorkOrderError,
            isUpdatingInProgress,
            resetUpdatingData,
        ],
    );
};
